export default "__VITE_ASSET__842fd911__"